// extracted by mini-css-extract-plugin
export default {"inputs":"SizingConstraints_inputs__t238P","highlightedData":"SizingConstraints_highlightedData__Vj2AO"};